<template>
  <div class="flex flex-col lg:mr-[2rem] md:mr[2rem] sm:mr[30px]">
    <div class="w-[220px] md:w-[340px]">
      <div class="border-[2px] border-brand-purple hover:[box-shadow:_0px_0px_24px_0px_rgba(251,101,255,0.50)_inset,0px_0px_24px_0px_rgba(251,101,255,0.80)] group relative transition-all">
        <div class="w-[84%] border-[2px] invisible opacity-0 border-brand-purple group-hover:[box-shadow:_0px_0px_24px_0px_rgba(251,101,255,0.50)_inset,0px_0px_24px_0px_rgba(251,101,255,0.80)] absolute h-[88%] top-[8%] left-[8%] group-hover:visible transition-all group-hover:opacity-100"></div>
        <div class="w-[68%] border-[2px] invisible opacity-0 border-brand-purple group-hover:[box-shadow:_0px_0px_24px_0px_rgba(251,101,255,0.50)_inset,0px_0px_24px_0px_rgba(251,101,255,0.80)] absolute h-[76%] top-[16%] left-[16%] group-hover:visible transition-all group-hover:opacity-100" ></div>
        <div class="w-[100%] relative z-20">
          <img class="w-[220px] h-[220px] md:w-[340px] md:h-[340px] h-auto object-cover object-bottom" :src="speaker.photo_src.filename" :alt="speaker.name">
        </div>
      </div>
      <div>
        <p class="px-6 mt-6 font-semibold text-center text-3xl"> {{ speaker.name }}</p>

        <p class="px-6 mt-1 font-medium font-mono text-center md:pb-0 pb-6 md:text-body text-[14px]" v-html="speaker.position"></p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
    props: {
        speaker: Object
    }
}
</script>

<style>

</style>
